import React, { useState, useEffect } from 'react';
import { Form, Button, Modal, Row, Col, Card, Spinner } from "react-bootstrap";
import Select from "react-select";
import MyApiClient from '../../../../api-client/MyApiClient';
import { italianProvinces } from '../../Util/enum';
import { segnalaMancanti } from '../../Util/campiMancanti';

const langOptions = [
    { value: "ar", label: "Arabo" },
    { value: "de", label: "Tedesco" },
    { value: "en", label: "Inglese" },
    { value: "it", label: "Italiano" },
    { value: "es", label: "Spagnolo" },
    { value: "fr", label: "Francese" },
    { value: "ru", label: "Russo" }
];

const optionsTipologia = [
    { value: "ASD", label: "ASD" },
    { value: "SSD", label: "SSD" },
    //{ value: "FREELANCER", label: "Libero professionista" },
    { value: "INDIVIDUAL_COMPANY", label: "Ditta individuale" },
    { value: "CAPITAL_COMPANY", label: "SRL / SPA" },
  ];

  const subOptions = [
    { value: "SCHOOL", label: "Scuola" },
    { value: "GYM", label: "Palestra" },
    { value: "RENTAL_SHOP", label: "Rental Shop" },
    { value: "CIRCLE", label: "Club" },
    { value: "SPORTS_CLUB", label: "Società Sportiva" },
  ];

const FormIDS = (props) => {

    const [profile, setProfile] = useState(props.profile);

    const [formData, setFormData] = useState({
        name: '',
        phoneNumber: '',
        languages: [],
        vatNumber: '',
        taxCode: '',
        incorporationYear: '',
        bookingUrl: '',
        description: '',
        legalRepresentativeId: '',
        legalRepresentativeFirstName: '',
        legalRepresentativeLastName: '',
        legalRepresentativeBirthPlace: '',
        legalRepresentativeCity: '',
        legalRepresentativeAddress: '',
        legalRepresentativeTaxCode: '',
        streetAddress: '',
        locality: '',
        country: '',
        postalCode: '',
        province: '',
        legalStreetAddress: '',
        legalLocality: '',
        legalCountry: '',
        legalPostalCode: '',
        legalProvince: '',
        referralId: '',
        email: ''
    });

    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');
    const [loadingShowed, setLoadingShowed] = useState(false);
    const [initialClubNature, setInitialClubNature] = useState('');

    const [memberOptions, setMemberOptions] = useState([]);

    const [isLegalRepresentativeNotMember, setIsLegalRepresentativeNotMember] = useState(true);
    const handleCheckboxChange = (event) => {
        setIsLegalRepresentativeNotMember(event.target.checked);
    };

    const [isLegalEqualsToOperativa, setIsLegalEqualsToOperativa] = useState(false);
    const handleCheckboxChange2 = (event) => {
        setIsLegalEqualsToOperativa(event.target.checked);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSelectChange = (selectedOptions) => {
        const selectedLanguages = selectedOptions.map(option => option.value);
        setFormData(prevState => ({
            ...prevState,
            languages: selectedLanguages
        }));
    };

    const handleSelectTipologiaStruttura = (selectedOptions) => {
		setFormData(prevState => ({
            ...prevState,
            clubNature: selectedOptions.value
        }));
    };

    const handleSelectSubTipologiaStruttura = (selectedOptions) => {
		setFormData(prevState => ({
            ...prevState,
            clubSubNature: selectedOptions.value
        }));
    };

    const handleSelectMemberStruttura = (selectedOptions) => {
		setFormData(prevState => ({
            ...prevState,
            legalRepresentativeId: selectedOptions.value
        }));
    };

    const handleSaveClick = (e) => {
        e.preventDefault();

        // Dati mancanti: niente finestra, si evidenziano i campi
        const m = [];
        const richiesto = (valore, campo, messaggio) => { if (!valore || !String(valore).trim()) m.push({ campo, messaggio }); };
        richiesto(formData.name, 'ids-name', 'Manca il nome della struttura');
        richiesto(formData.phoneNumber, 'ids-phoneNumber', 'Manca il telefono');
        if (formData.languages.length === 0) m.push({ campo: 'ids-languages', messaggio: 'Manca almeno una lingua parlata' });
        richiesto(formData.incorporationYear, 'ids-incorporationYear', "Manca l'anno di costituzione");
        richiesto(formData.clubNature, 'ids-clubNature', 'Manca la tipologia giuridica');
        richiesto(formData.clubSubNature, 'ids-clubSubNature', 'Manca la natura della struttura');
        // Sempre obbligatori nome e cognome del rappresentante legale
        richiesto(formData.legalRepresentativeFirstName, 'ids-legalRepresentativeFirstName', 'Manca il nome del rappresentante legale');
        richiesto(formData.legalRepresentativeLastName, 'ids-legalRepresentativeLastName', 'Manca il cognome del rappresentante legale');
        richiesto(formData.legalRepresentativeBirthPlace, 'ids-legalRepresentativeBirthPlace', 'Manca il luogo di nascita del rappresentante legale');
        richiesto(formData.legalRepresentativeCity, 'ids-legalRepresentativeCity', 'Manca la città di residenza del rappresentante legale');
        richiesto(formData.legalRepresentativeAddress, 'ids-legalRepresentativeAddress', "Manca l'indirizzo di residenza del rappresentante legale");
        richiesto(formData.legalRepresentativeTaxCode, 'ids-legalRepresentativeTaxCode', 'Manca il codice fiscale del rappresentante legale');
        richiesto(formData.streetAddress, 'ids-streetAddress', 'Manca la via della sede operativa');
        richiesto(formData.locality, 'ids-locality', 'Manca la località della sede operativa');
        richiesto(formData.province, 'ids-province', 'Manca la provincia della sede operativa');
        richiesto(formData.postalCode, 'ids-postalCode', 'Manca il CAP della sede operativa');
        if (!isLegalEqualsToOperativa) {
            richiesto(formData.legalStreetAddress, 'ids-legalStreetAddress', 'Manca la via della sede legale');
            richiesto(formData.legalLocality, 'ids-legalLocality', 'Manca la località della sede legale');
            richiesto(formData.legalProvince, 'ids-legalProvince', 'Manca la provincia della sede legale');
            richiesto(formData.legalPostalCode, 'ids-legalPostalCode', 'Manca il CAP della sede legale');
        }

        if (segnalaMancanti(m) > 0) return;

        const saveData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    let profile_send = JSON.parse(JSON.stringify(props.profile));

                    profile_send.club.name = formData.name;
                    profile_send.club.phoneNumber = formData.phoneNumber;
                    profile_send.club.incorporationYear = formData.incorporationYear;
                    profile_send.club.bookingUrl = formData.bookingUrl;
                    profile_send.club.description = formData.description;
                    profile_send.club.legalRepresentativeId = formData.legalRepresentativeId!=='' ? formData.legalRepresentativeId : null;
                    profile_send.club.legalRepresentativeFirstName = formData.legalRepresentativeFirstName;
                    profile_send.club.legalRepresentativeLastName = formData.legalRepresentativeLastName;
                    profile_send.club.legalRepresentativeBirthPlace = formData.legalRepresentativeBirthPlace;
                    profile_send.club.legalRepresentativeCity = formData.legalRepresentativeCity;
                    profile_send.club.legalRepresentativeAddress = formData.legalRepresentativeAddress;
                    profile_send.club.legalRepresentativeTaxCode = formData.legalRepresentativeTaxCode;
                    
                    profile_send.club['address'] = {}
                    profile_send.club.address.streetAddress = formData.streetAddress;
                    profile_send.club.address.locality = formData.locality;
                    profile_send.club.address.country = 'Italia';
                    profile_send.club.address.postalCode = formData.postalCode;
                    profile_send.club.address.province = formData.province;

                    profile_send.club['legalAddress'] = {}
                    if(isLegalEqualsToOperativa) {
                        profile_send.club.legalAddress.streetAddress = formData.streetAddress;
                        profile_send.club.legalAddress.locality = formData.locality;
                        profile_send.club.legalAddress.country = 'Italia';
                        profile_send.club.legalAddress.postalCode = formData.postalCode;
                        profile_send.club.legalAddress.province = formData.province;
                    } else {
                        profile_send.club.legalAddress.streetAddress = formData.legalStreetAddress;
                        profile_send.club.legalAddress.locality = formData.legalLocality;
                        profile_send.club.legalAddress.country = 'Italia';
                        profile_send.club.legalAddress.postalCode = formData.legalPostalCode;
                        profile_send.club.legalAddress.province = formData.legalProvince;
                    }

                    profile_send.club.spokenLocales = formData.languages;
                    profile_send.club.clubNature = formData.clubNature;
                    profile_send.club.clubSubNature = formData.clubSubNature;

                    delete profile_send.club.logo;
                    delete profile_send.club.pictures;

                    setLoadingShowed(true);
                    const saveResult = await apiClient.updateProfile(token, profile_send);
                    setLoadingShowed(false);

                    if (saveResult && saveResult.error) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
                        setModalShowed(true);
                    } else if (props.superAdmin) {
                        // Super admin sulla scheda della struttura: la sua sessione non c'entra, si ricarica la scheda
                        props.onSalvato?.();
                    } else {
                        // Mantieni allineato clubNature in sessionStorage così la voce di menu
                        // "Organismo sociale" compare subito, senza dover rifare login.
                        try {
                            const tokenDetailsString = sessionStorage.getItem('userDetails');
                            if (tokenDetailsString) {
                                const tokenDetails = JSON.parse(tokenDetailsString);
                                tokenDetails.clubNature = formData.clubNature;
                                sessionStorage.setItem('userDetails', JSON.stringify(tokenDetails));
                            }
                        } catch (e) {
                            console.error('Impossibile aggiornare clubNature in sessionStorage:', e);
                        }
                        window.location.reload();
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        saveData();
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    const [membershipDataUsers] = await Promise.all([
                        apiClient.getMemberships(token,'MEMBER',null,'CONFIRMED')
                    ]);

                    if(membershipDataUsers) {
						let data_member = [];
						membershipDataUsers.forEach(element => {
							let member_row = {
								"value": element.userId,
								"label": element.name
							};
							data_member.push(member_row);
						})

						setMemberOptions(data_member);
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {

        if (props.profile && props.profile.club) {
            let structureData = props.profile;

            setProfile(structureData);

            if (structureData && structureData.club) {
                let myFormData = {};
                myFormData.name = structureData.club.name ? structureData.club.name : '';
                myFormData.email = structureData.club.email ? structureData.club.email : '';
                myFormData.referralId = structureData.club.referralId ? structureData.club.referralId : '';
                myFormData.phoneNumber = structureData.club.phoneNumber ? structureData.club.phoneNumber : '';
                myFormData.languages = structureData.club.spokenLocales ? structureData.club.spokenLocales : [];
                myFormData.clubNature = structureData.club.clubNature ? structureData.club.clubNature : '';
                if(structureData.club.clubNature) {
                    setInitialClubNature(structureData.club.clubNature);
                }
                myFormData.clubSubNature = structureData.club.clubSubNature ? structureData.club.clubSubNature : '';
                myFormData.vatNumber = structureData.club.vatNumber ? structureData.club.vatNumber : '';
                myFormData.taxCode = structureData.club.taxCode ? structureData.club.taxCode : '';
                myFormData.incorporationYear = structureData.club.incorporationYear ? structureData.club.incorporationYear : null;
                myFormData.bookingUrl = structureData.club.bookingUrl ? structureData.club.bookingUrl : '';
                myFormData.description = structureData.club.description ? structureData.club.description : '';
                myFormData.legalRepresentativeId = structureData.club.legalRepresentativeId ? structureData.club.legalRepresentativeId : '';
                myFormData.legalRepresentativeFirstName = structureData.club.legalRepresentativeFirstName ? structureData.club.legalRepresentativeFirstName : '';
                myFormData.legalRepresentativeLastName = structureData.club.legalRepresentativeLastName ? structureData.club.legalRepresentativeLastName : '';
                myFormData.legalRepresentativeBirthPlace = structureData.club.legalRepresentativeBirthPlace ? structureData.club.legalRepresentativeBirthPlace : '';
                myFormData.legalRepresentativeCity = structureData.club.legalRepresentativeCity ? structureData.club.legalRepresentativeCity : '';
                myFormData.legalRepresentativeAddress = structureData.club.legalRepresentativeAddress ? structureData.club.legalRepresentativeAddress : '';
                myFormData.legalRepresentativeTaxCode = structureData.club.legalRepresentativeTaxCode ? structureData.club.legalRepresentativeTaxCode : '';
                myFormData.streetAddress = structureData.club.address ? structureData.club.address.streetAddress : '';
                myFormData.locality = structureData.club.address ? structureData.club.address.locality : '';
                myFormData.country = structureData.club.address ? structureData.club.address.country : '';
                myFormData.postalCode = structureData.club.address ? structureData.club.address.postalCode : '';
                myFormData.province = structureData.club.address ? structureData.club.address.province : '';
                myFormData.legalStreetAddress = structureData.club.legalAddress ? structureData.club.legalAddress.streetAddress : '';
                myFormData.legalLocality = structureData.club.legalAddress ? structureData.club.legalAddress.locality : '';
                myFormData.legalCountry = structureData.club.legalAddress ? structureData.club.legalAddress.country : '';
                myFormData.legalPostalCode = structureData.club.legalAddress ? structureData.club.legalAddress.postalCode : '';
                myFormData.legalProvince = structureData.club.legalAddress ? structureData.club.legalAddress.province : '';

                if(myFormData.streetAddress === myFormData.legalStreetAddress && myFormData.locality === myFormData.legalLocality &&
                    myFormData.country === myFormData.legalCountry && myFormData.postalCode === myFormData.legalPostalCode && myFormData.province === myFormData.legalProvince) {
                        
                        setIsLegalEqualsToOperativa(true);
                }

                // Sempre abilitato - Il rappresentante legale non fa parte dei soci
                setIsLegalRepresentativeNotMember(true);

                setFormData(myFormData);
            }
        }

    }, [props]);


    return (
        <>
            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-12">
                    <Card>
                        <Card.Header><h4 className="card-title">IDS</h4></Card.Header>
                        <Card.Body>
                            <Form>
                                <Row>
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2" htmlFor="ids-name">Nome Struttura *</Form.Label>
                                        <Form.Control style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'Inserisci Nome'} type="text" id="ids-name" name="name" value={formData.name} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2" htmlFor="ids-phoneNumber">Telefono *</Form.Label>
                                        <Form.Control style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'Inserisci Telefono'} type="text" id="ids-phoneNumber" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2">Email</Form.Label>
                                        <Form.Control 
                                            style={{
                                                color: 'rgba(108,117,125,0.6)', 
                                                backgroundColor: '#f2f2f2', 
                                                paddingLeft: "15px",
                                                marginTop: "8px", 
                                                fontWeight: "normal" 
                                            }} 
                                            placeholder=""
                                            type="email" 
                                            name="email" 
                                            value={formData.email} 
                                            onChange={handleChange} 
                                            disabled={true} 
                                        />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-languages">Lingue parlate *</Form.Label>
                                        <Select
                                            inputId="ids-languages"
                                            placeholder="Seleziona lingue"
                                            value={langOptions.filter(option => formData.languages.includes(option.value))}
                                            isMulti
                                            options={langOptions}
                                            onChange={handleSelectChange}
                                            isDisabled={props.isDisabled}
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    color: "#000000",
                                                    paddingLeft: "15px",
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-clubNature">Tipologia giuridica *</Form.Label>
                                        <Select
                                            inputId="ids-clubNature"
                                            // La natura, una volta scelta, la cambia solo il super admin
                                            isDisabled={props.isDisabled || (!!initialClubNature && !props.superAdmin)}
                                            placeholder="Seleziona la tipologia"
                                            value={optionsTipologia.filter(option => formData.clubNature === option.value)}
                                            onChange={handleSelectTipologiaStruttura}
                                            options={optionsTipologia}
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    color: "#000000",
                                                    paddingLeft: "15px",
                                                })
                                            }}
                                        />
                                        {!formData.clubNature && (
                                            <div className="alert alert-warning mt-2 p-2 fs-14" role="alert" style={{color: 'black'}}>
                                                <strong>Attenzione!</strong> Una volta scelta la tua tipologia giuridica non potrai più modificarla.
                                            </div>
                                        )}
                                    </Col>
                                    <Col className='col-xl-6'>
                                        <Form.Label htmlFor="ids-clubSubNature">Natura struttura *</Form.Label>
                                        <Select
                                            inputId="ids-clubSubNature"
                                            isDisabled={props.isDisabled}
                                            placeholder="Seleziona la natura"
                                            value={subOptions.filter(option => formData.clubSubNature === option.value)}
                                            onChange={handleSelectSubTipologiaStruttura}
                                            options={subOptions}
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    color: "#000000",
                                                    paddingLeft: "15px",
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2" htmlFor="ids-incorporationYear">Anno di costituzione *</Form.Label>
                                        <Form.Control style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'Inserisci anno di costituzione'} type="text" id="ids-incorporationYear" name="incorporationYear" value={formData.incorporationYear} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2">URL sito web</Form.Label>
                                        <Form.Control style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'www.sitoweb.it'} type="text" name="bookingUrl" value={formData.bookingUrl} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-12">
                                        <Form.Label className="mb-2">Descrizione</Form.Label>
                                        <Form.Control rows={10} style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'Inserisci la descrizione della tua struttura'} as="textarea" name="description" value={formData.description} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h5>DonAction Code</h5></Card.Header>
                        <Card.Body>
                            <Row className="mt-4">
                                <Col className="col-xl-12">
                                    <Form.Control rows={10} style={{color: '#000000'}} name="referralId" value={formData.referralId?formData.referralId:'-'} disabled={true} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h5>Rappresentante legale</h5></Card.Header>
                        <Card.Body>
                            <Form>
                                {/* Campo nascosto: `checked` non ha senso su un input hidden
                                    (usa solo value) e senza onChange generava un warning React. */}
                                <input
                                    type="hidden"
                                    value={isLegalRepresentativeNotMember}
                                />
                                {/* Campi nome e cognome sempre visibili */}
                                <Row>
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-legalRepresentativeFirstName">Nome *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci nome' id="ids-legalRepresentativeFirstName" name="legalRepresentativeFirstName" value={formData.legalRepresentativeFirstName} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-legalRepresentativeLastName">Cognome *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci cognome' id="ids-legalRepresentativeLastName" name="legalRepresentativeLastName" value={formData.legalRepresentativeLastName} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-legalRepresentativeBirthPlace">Luogo di nascita *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci luogo di nascita' id="ids-legalRepresentativeBirthPlace" name="legalRepresentativeBirthPlace" value={formData.legalRepresentativeBirthPlace} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-legalRepresentativeCity">Città di residenza *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci città di residenza' id="ids-legalRepresentativeCity" name="legalRepresentativeCity" value={formData.legalRepresentativeCity} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-legalRepresentativeAddress">Indirizzo di residenza *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci indirizzo di residenza' id="ids-legalRepresentativeAddress" name="legalRepresentativeAddress" value={formData.legalRepresentativeAddress} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-legalRepresentativeTaxCode">Codice Fiscale *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci codice fiscale' id="ids-legalRepresentativeTaxCode" name="legalRepresentativeTaxCode" value={formData.legalRepresentativeTaxCode} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h5>Sede operativa</h5></Card.Header>
                        <Card.Body>
                            <Form>
                                <Row>
                                    <Col className="col-xl-4">
                                        <Form.Label htmlFor="ids-streetAddress">Via *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci indirizzo' id="ids-streetAddress" name="streetAddress" value={formData.streetAddress} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-4">
                                        <Form.Label htmlFor="ids-locality">Località *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci località' id="ids-locality" name="locality" value={formData.locality} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-4">
                                        <Form.Label htmlFor="ids-province">Provincia *</Form.Label>
                                        <Select
                                            isDisabled={props.isDisabled ? true : false}
                                            placeholder="Seleziona la provincia"
                                            name="province"
                                            inputId="ids-province"
                                            value={italianProvinces.find(o => o.value === formData.province || o.label === formData.province) || null}
                                            onChange={(selected) => setFormData(prev => ({ ...prev, province: selected ? selected.value : '' }))}
                                            options={italianProvinces}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    color: '#000000',
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-postalCode">CAP *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci CAP' id="ids-postalCode" name="postalCode" value={formData.postalCode} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Paese</Form.Label>
                                        <Form.Control
                                            style={{
                                                color: 'rgba(108,117,125,0.6)',
                                                backgroundColor: '#f2f2f2',
                                                paddingLeft: "15px",
                                                marginTop: "8px",
                                                fontWeight: "normal"
                                            }}
                                            type="text"
                                            name="country"
                                            value="Italia"
                                            disabled={true}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h5>Sede legale</h5></Card.Header>
                        <Card.Body>
                            <Form>
                                <Row className="mt-2 mb-4">
                                    <Col className="col-xl-12">
                                        <div>
                                            <label>
                                                <input
                                                type="checkbox"
                                                checked={isLegalEqualsToOperativa}
                                                onChange={handleCheckboxChange2}
                                                disabled={props.isDisabled ? true : false}
                                                />
                                                &nbsp;&nbsp;&nbsp;Coincide con quella operativa
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                {!isLegalEqualsToOperativa && <Row>
                                    <Col className="col-xl-4">
                                        <Form.Label htmlFor="ids-legalStreetAddress">Via *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci indirizzo' id="ids-legalStreetAddress" name="legalStreetAddress" value={formData.legalStreetAddress} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-4">
                                        <Form.Label htmlFor="ids-legalLocality">Località *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci località' id="ids-legalLocality" name="legalLocality" value={formData.legalLocality} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-4">
                                        <Form.Label htmlFor="ids-legalProvince">Provincia *</Form.Label>
                                        <Select
                                            isDisabled={props.isDisabled ? true : false}
                                            placeholder="Seleziona la provincia"
                                            name="legalProvince"
                                            inputId="ids-legalProvince"
                                            value={italianProvinces.find(o => o.value === formData.legalProvince || o.label === formData.legalProvince) || null}
                                            onChange={(selected) => setFormData(prev => ({ ...prev, legalProvince: selected ? selected.value : '' }))}
                                            options={italianProvinces}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    color: '#000000',
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>}
                                {!isLegalEqualsToOperativa && <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label htmlFor="ids-legalPostalCode">CAP *</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000'}} placeholder='Inserisci CAP' id="ids-legalPostalCode" name="legalPostalCode" value={formData.legalPostalCode} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Paese</Form.Label>
                                        <Form.Control
                                            style={{
                                                color: 'rgba(108,117,125,0.6)',
                                                backgroundColor: '#f2f2f2',
                                                paddingLeft: "15px",
                                                marginTop: "8px",
                                                fontWeight: "normal"
                                            }}
                                            type="text"
                                            name="legalCountry"
                                            value="Italia"
                                            disabled={true}
                                            readOnly
                                        />
                                    </Col>
                                </Row>}
                            </Form>
                        </Card.Body>
                    </Card>
                    {!props.isDisabled && <div className="d-flex justify-content-end gap-4 mt-4"><Button type="button" onClick={handleSaveClick} className="btn btn-primary btn-add">Salva</Button></div>}
                </div>
            </Row>
        </>
    )
}

export default FormIDS